export const PRIORITY_OPTIONS = [
    { 'label': 'Low', value: 'Low' },
    { 'label': 'Medium', value: 'Medium' },
    { 'label': 'High', value: 'High' },
]
export const YESNO_OPTIONS = [
    { 'label': 'Yes', value: 'Yes' },
    { 'label': 'No', value: 'No' },
]